import { z } from 'zod';
import { ErrorResponseSchema } from '../../common/base';

/**
 * Schema for unread notification counts by type
 */
export const UnreadCountsSchema = z.object({
  chat: z.number(),
  sale: z.number(),
  purchase: z.number(),
  transaction: z.number(),
  system: z.number(),
  total: z.number(),
});

/**
 * Success response schema for GET /api/notifications/unread-counts
 */
export const UnreadCountsSuccessSchema = z.object({
  success: z.literal(true),
  counts: UnreadCountsSchema,
});

/**
 * Combined response schema for unread counts endpoint
 * GET /api/notifications/unread-counts
 *
 * Discriminated union based on success field
 *
 * @example
 * ```typescript
 * const response = UnreadCountsResponseSchema.parse(data);
 * if (response.success) {
 *   console.log('Total unread:', response.counts.total);
 * } else {
 *   console.error('Error:', response.error);
 * }
 * ```
 */
export const UnreadCountsResponseSchema = z.discriminatedUnion('success', [
  UnreadCountsSuccessSchema,
  ErrorResponseSchema,
]);

export type UnreadCounts = z.infer<typeof UnreadCountsSchema>;
export type UnreadCountsSuccess = z.infer<typeof UnreadCountsSuccessSchema>;
export type UnreadCountsResponse = z.infer<typeof UnreadCountsResponseSchema>;
